import { render, staticRenderFns } from "./IconWarningBrandBlue.vue?vue&type=template&id=7fbb71be"
import script from "./IconWarningBrandBlue.vue?vue&type=script&lang=js"
export * from "./IconWarningBrandBlue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports